import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import course05 from "../../../course/course-05/course";
import lesson0227 from "../../course-02/lesson-27/lesson";
import lesson0503 from "../lesson-03/lesson";
import lesson0506 from "../lesson-06/lesson";
import lesson0509 from "../lesson-09/lesson";
import lesson0510 from "../lesson-10/lesson";
import lesson0511 from "../lesson-11/lesson";
import lesson0513 from "../lesson-13/lesson";
import lesson0515 from "../lesson-15/lesson";
import lesson0528 from "../lesson-28/lesson";
import lesson0529 from "../lesson-29/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2e5abe9d-b9c2-4857-9023-c2c0f05dedb3",
    course: { id: course02.id, slug: course02.slug as string, name: course02.name, publicId: course02.publicId },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0227),
    lesson: lesson0227,
  },
  {
    id: "83356ad1-fabc-4499-bb28-6d756f740028",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
  {
    id: "bc6fedfb-6416-46b8-b71d-d2451d62eeef",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
  {
    id: "8ae2fb3f-08ef-4321-964d-e1b2fb980cbf",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0509),
    lesson: lesson0509,
  },
  {
    id: "44aa5231-fc8b-4feb-a921-2a9177ca8328",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0510),
    lesson: lesson0510,
  },
  {
    id: "e0a05a2f-43de-4c07-9e47-87db51c635df",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0511),
    lesson: lesson0511,
  },
  {
    id: "fdf5fe9d-4a65-4af4-b230-36ffe54c92cf",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0513),
    lesson: lesson0513,
  },
  {
    id: "ca63fe59-b2a9-48d9-90ae-856fff418521",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0515),
    lesson: lesson0515,
  },
  {
    id: "1040667b-9ff2-4e43-9051-ec7f0fe8978d",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0528),
    lesson: lesson0528,
  },
  {
    id: "3ffb956f-a03a-4f44-8b54-95717deb1748",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0529),
    lesson: lesson0529,
  },
];

export default lessonLinks;
